import { render } from "./FormBagsizeMobile.vue?vue&type=template&id=0ec5330a&scoped=true&ts=true"
import script from "./FormBagsizeMobile.vue?vue&type=script&lang=ts"
export * from "./FormBagsizeMobile.vue?vue&type=script&lang=ts"

import "./FormBagsizeMobile.vue?vue&type=style&index=0&id=0ec5330a&scoped=true&lang=scss"

import exportComponent from "/Users/gerald/Projects/designium/RandselSimulation/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ec5330a"]])

export default __exports__